// extracted by mini-css-extract-plugin
module.exports = {"first":"reports_first__2iBSb","repocont":"reports_repocont__yCiol","second":"reports_second__119oW","imgs":"reports_imgs__3TaLH","cont2":"reports_cont2__1LLjr"};